/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CompanyExcelResultDto } from '../models/company-excel-result-dto';
import { excelControllerCompanyExcelUpload } from '../fn/excel/excel-controller-company-excel-upload';
import { ExcelControllerCompanyExcelUpload$Params } from '../fn/excel/excel-controller-company-excel-upload';

@Injectable({ providedIn: 'root' })
export class ExcelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `excelControllerCompanyExcelUpload()` */
  static readonly ExcelControllerCompanyExcelUploadPath = '/api/excel/company';

  /**
   * 엑셀로 받은 아동 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `excelControllerCompanyExcelUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerCompanyExcelUpload$Response(params: ExcelControllerCompanyExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyExcelResultDto>> {
    return excelControllerCompanyExcelUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 아동 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `excelControllerCompanyExcelUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  excelControllerCompanyExcelUpload(params: ExcelControllerCompanyExcelUpload$Params, context?: HttpContext): Observable<CompanyExcelResultDto> {
    return this.excelControllerCompanyExcelUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyExcelResultDto>): CompanyExcelResultDto => r.body)
    );
  }

}
